// src/services/authService.ts

import api from './api';
import axios from 'axios';
import type { ILoginResponse, ISignupResponse } from '../types/auth';
import type { User } from '../types/user';

// 🔐 Login with credentials
export const login = async (payload: {
  email: string;
  password: string;
}): Promise<ILoginResponse> => {
  const res = await api.post('/auth/login', payload);
  return res.data;
};

// 📝 Signup new user
export const signup = async (payload: {
  name: string;
  email: string;
  password: string;
}): Promise<ISignupResponse> => {
  const res = await api.post('/auth/signup', payload);
  return res.data;
};

// 🚪 Logout user
export const logout = async () => {
  return api.get('/auth/logout');
};

// 🙋‍♂️ Fetch current logged-in user
export const getCurrentUser = async (): Promise<User | null> => {
  try {
    const res = await api.get<{ user: User }>('/auth/me');
    return res.data.user;
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response && (error.response.status === 401 || error.response.status === 404)) {
      return null;
    }
    throw error;
  }
};

// 🔐 Google OAuth login redirect
export const googleAuth = () => {
  window.location.href = `${import.meta.env.VITE_API_BASE_URL}/auth/google`;
};

// We will export a single object for a cleaner API
const authService = {
  login,
  signup,
  logout,
  getCurrentUser,
  googleAuth,
};

export default authService;